__turbopack_context__.v({
  "drawer": "ScrollableDrawer-module-scss-module__y365Nq__drawer",
  "isClosing": "ScrollableDrawer-module-scss-module__y365Nq__isClosing",
  "isFadingOut": "ScrollableDrawer-module-scss-module__y365Nq__isFadingOut",
  "isOpen": "ScrollableDrawer-module-scss-module__y365Nq__isOpen",
  "listingsBackdrop": "ScrollableDrawer-module-scss-module__y365Nq__listingsBackdrop",
});
